import React, { useState, useEffect } from 'react';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaRotasDeColeta from './components/TabelaRotasDeColeta';
import Loading from 'components/Loading/Loading';
import NovaRota from './NovaRota';
import FichaRota from './FichaRota';

//Api
import rotaColeta_api from '../../../api/rotaColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';
export default function RotasColeta({ permissao }) {
    //Ações da tabela de listagem das rotas
    const actions = [actionsTable.visualizar((rowData) => setFicha(rowData.id))];

    //Estado de controle da tela de nova rota de coleta
    const [novaRota, setNovaRota] = useState(false);

    //Estado de controle da tela de ficha de rota de coleta
    const [ficha, setFicha] = useState(null);

    //Estado de controle para o loading na tela
    const [loading, setLoading] = useState(false);

    //Estado que guarda a lista de rotas de coleta do transportador
    const [rotas, setRotas] = useState([]);

    const loadRotas = () => {
        setLoading(true);
        rotaColeta_api.GetList().then(response => {
            setRotas(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega todas as rotas de coleta do transportador
    useEffect(() => {
        loadRotas();
    }, []);

    //Função do clique do botão de voltar 
    const onClickVoltar = () => {
        setFicha(null);
        setNovaRota(false);
        loadRotas();
    }

    //Controle da tela de nova rota
    if (novaRota) {
        return <NovaRota permissao={permissao} btnVoltar={onClickVoltar} />
    }

    //Controle da tela de ficha
    if (ficha) {
        return <FichaRota id={ficha} permissao={permissao} btnVoltar={onClickVoltar} />
    }
    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={() => setNovaRota(true)} >
                <TabelaRotasDeColeta items={rotas} actions={actions} />
            </MainCard>
        </>
    )
}